import logo from './logo.svg';
import './App.css';
import React from 'react';
import AddPokemon from './components/AddPokemon.js';
import PokemonTeam from './components/PokemonTeam.js';
import RenamePokemon from './components/RenamePokemon.js';
import DeletePokemon from './components/DeletePokemon.js';

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            team: 1,
        };
    }

    team = event => {
        this.setState({team: Math.min(9, Math.max(1, event.target.value))});
    }

    render() {
        return (
            <div>
                <h1>Pokemon Team Manager</h1>
                <h3>Current Team</h3>
                <input type="number" min="1" max="9" value={this.state.team} onChange={this.team} placeholder="Team"/>
                <br/>
                <br/>
                <PokemonTeam team={this.state.team}/>
                <hr/>
                <AddPokemon team={this.state.team}/>
                <hr/>
                <DeletePokemon team={this.state.team}/>
                <hr/>
                <RenamePokemon team={this.state.team}/>
            </div>
        );
    }
}

export default App;
